import React from 'react';
import { CircleCheckBigIcon } from 'lucide-react';
import { CHECKOUT_URL, ctaSubline } from '../data/offer';
type CTAButtonProps = {
  label: string;
  id?: string;
  subline?: string | null;
  tone?: 'light' | 'dark';
};
export function CTAButton({
  label,
  id,
  subline = ctaSubline,
  tone = 'light'
}: CTAButtonProps) {
  return <div className="mx-auto w-full max-w-xl text-center" data-id="element-105" data-mp="2fy0erlvcynyh">
      <a id={id} href={CHECKOUT_URL} className="group flex w-full items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-5 text-center text-[17px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_6px_0_#0E6B31] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-[#18B252] active:translate-y-1 active:shadow-[0_2px_0_#0E6B31] focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 sm:text-xl" data-id="element-106" data-mp="2tyunk5mbiqxo">
        <CircleCheckBigIcon className="h-6 w-6 shrink-0" aria-hidden="true" data-id="element-107" data-mp="38pa9xnqh04xf" />
        <span className="text-balance" data-id="element-108" data-mp="199elkjbamkiu">{label}</span>
      </a>
      {subline && <p className={`mt-4 text-sm leading-relaxed ${tone === 'dark' ? 'text-white/75' : 'text-muted'}`} data-id="element-109" data-mp="1dahz2z5vc4gw">
          {subline}
        </p>}
    </div>;
}